function getNestedValue (fieldName, dataItem) {
  if (!fieldName) {
    return dataItem
  }
  const path = fieldName.replace(/([^.])\[(\d+)\]/g, '$1.$2').replace(/\[(\d+)\]/, '$1').split('.')
  let data = dataItem
  path.forEach((p) => {
    data = data ? data[p] : undefined
  })
  
  return data
}

export default getNestedValue
